const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        user: null,
        url:null,
        isFetching: true,
        error: action.error,
      };
    case "LOGIN_SUCCESS":
      return {
        user: action.payload,
        url:action.ruta,
        isFetching: false,
        error: false,
        
      };
    case "LOGIN_FAILURE":
      return {
        user: null,
        url:null,
        isFetching: false,
        error: action.error,
      };
    case "REGISTER_START":
      return {
        user: null,
        url:null,
        isFetching: true,
        error: action.error,
      };
    case "REGISTER_SUCCESS":
      return {
        user: action.payload,
        url:action.ruta,
        isFetching: false,
        error: false,
        
      };
    case "REGISTER_FAILURE":
      return {
        user: null,
        url:null,
        isFetching: false,
        error: action.error,
      };  
    case "LOGOUT":
      return {
        user: null,
        url:null,
        isFetching: false,
        error: false,
      };
    default:
      return { ...state };
  }
};

export default AuthReducer;
